module.exports = __webpack_public_path__ + "static/media/layout8-vid.498433c1.svg";